import _defineProperty from "@babel/runtime/helpers/defineProperty";
/**
 * Copyright IBM Corp. 2016, 2020
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import classnames from 'classnames';
import ddsSettings from '@carbon/ibmdotcom-utilities/es/utilities/settings/settings';
import React from 'react';
import settings from 'carbon-components/es/globals/js/settings';
var stablePrefix = ddsSettings.stablePrefix;
var prefix = settings.prefix;
/**
 * Horizontal Rule component.
 */

var HorizontalRule = function HorizontalRule(_ref) {
  var _classnames;

  var type = _ref.type,
      size = _ref.size,
      contrast = _ref.contrast,
      weight = _ref.weight;
  return React.createElement("hr", {
    "data-autoid": "".concat(stablePrefix, "--hr"),
    className: classnames("".concat(prefix, "--hr"), (_classnames = {}, _defineProperty(_classnames, "".concat(prefix, "--hr--").concat(type), type), _defineProperty(_classnames, "".concat(prefix, "--hr--").concat(contrast), contrast), _defineProperty(_classnames, "".concat(prefix, "--hr--").concat(size), size), _defineProperty(_classnames, "".concat(prefix, "--hr--").concat(weight), weight), _classnames))
  });
};

export default HorizontalRule;